import {
  setIsLoading,
  setSuccess,
  setError,
  initialState
} from './move-in-meter-read-slice';
import { sendMoveInMeterRead } from 'api/meter-reads';
import { getErrors } from 'api/client';

export const sendMoveInMeterReadThunk = (payload) => async (dispatch) => {
  try {
    dispatch(setIsLoading());
    const response = await sendMoveInMeterRead(payload);
    const errors = response.errors;
    const hasErrors = !!errors?.length;

    if (hasErrors) {
      return Promise.reject(response);
    }

    dispatch(setError(initialState.errors));

    dispatch(setSuccess(response));

    return Promise.resolve(response);
  } catch (e) {
    const errors = getErrors(e);
    errors && dispatch(setError(errors));

    return Promise.reject(errors);
  }
};
